import React from 'react';
import { FullColoredTicketButton, TicketActionButton } from '../../common/buttonsComponents';
import { NewMessageWarningPopup } from './NewMessageWarningPopup.styles';

export default ({ show, toggle, sendAnyway, warningMessage, iconName }) => {
  iconName = `images/${iconName ? iconName : 'Warning.svg'}`;

  return (
    show && (
      <NewMessageWarningPopup iconName={iconName}>
        <div className="Icon" />
        <p className="Message">{warningMessage}</p>
        <div className="Buttons">
          <FullColoredTicketButton active onClick={() => toggle()}>
            REVIEW
          </FullColoredTicketButton>
          {!!sendAnyway && (
            <TicketActionButton
              onClick={() => {
                toggle();
                sendAnyway();
              }}
            >
              IGNORE {'&'} SEND
            </TicketActionButton>
          )}
        </div>
      </NewMessageWarningPopup>
    )
  );
};
